import React from 'react';
import SocialMediaLinks from '../Footer/SocialMediaLinks';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer-container shadow">
      <div className="footer-content">
        <p>&copy; 2024 Claudiu Dobre. All rights reserved.</p>
        <SocialMediaLinks />
      </div>
    </footer>
  );
};

export default Footer;